import { FC, ReactNode } from 'react'
import Desktop from '@components/Items/Desktop'
import Mobile from '@components/Items/Mobile'

type PropTypes = {
  children: ReactNode
  totalCount: number
}

const FiltersLayout: FC<PropTypes> = ({ children, totalCount }) => {
  return (
    <>
      <div className="hidden md:block">
        <Desktop totalCount={totalCount}>{children}</Desktop>
      </div>
      <div className="md:hidden">
        <Mobile totalCount={totalCount}>{children}</Mobile>
      </div>
    </>
  )
}

export default FiltersLayout
